/**
 * @file The name every derived-value message quotes: the entry's own short
 * label when an admin gave it one, otherwise the resolved target — a field
 * label, or the table a row projection owns. Consumers: the Derived values
 * list, the delete and cycle modals, and the "already derived by" reason on a
 * taken target. Invariants: the target is the fallback identity, so an
 * unresolvable id renders raw rather than blank; `'tableId' in target`
 * distinguishes the two target shapes — `FormDeriveEntry` cannot be narrowed
 * from `source.kind`, and a cast here would mislabel four of the five arms. A
 * projection names the WHOLE table and no column, because one table has one
 * owning derive and every declared column belongs to it.
 */
import type { FormDeriveEntry } from '#types';
import type { FormDeriveLabelResolvers } from './formDeriveLabelResolvers';

function formDeriveEntryName(entry: FormDeriveEntry, labels: FormDeriveLabelResolvers): string {
  const shortLabel = entry.description?.shortLabel;
  if (shortLabel) return shortLabel;

  const { target } = entry;
  if ('tableId' in target) return labels.tableLabel(target.tableId) ?? target.tableId;
  return labels.fieldLabel(target.fieldId) ?? target.fieldId;
}

export { formDeriveEntryName };
